// Aguarde o DOM carregar
document.addEventListener('DOMContentLoaded', function() {

  // Inicializa Swiper
  const swiper = new Swiper('.banner-swiper', {
    // Configurações básicas
    loop: true,
    effect: 'fade', // ou 'slide'
    fadeEffect: {
      crossFade: true
    },
    speed: 800,
    
    // Paginação
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    
    // Navegação
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    
    // Acessibilidade
    keyboard: {
      enabled: true,
    },
    
    // A11y
    a11y: {
      enabled: true,
    }
  });

  // Inicializa GLightbox para vídeos
  const lightbox = GLightbox({
    selector: '.glightbox-play',
    touchNavigation: true,
    loop: false,
    autoplayVideos: true,
    closeButton: true,
    skin: 'clean',
    zoomable: false,
    draggable: true,
    // Configurações para vídeos
    videos: {
      youtube: {
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3
      },
      vimeo: {
        byline: false,
        portrait: false,
        title: false
      }
    }
  });

  // Opcional: Pausar autoplay ao abrir o vídeo
  document.querySelectorAll('.glightbox-play').forEach(btn => {
    btn.addEventListener('click', () => {
      swiper.autoplay.stop();
    });
  });

  // Opcional: Retomar autoplay ao fechar o modal
  document.addEventListener('glightbox_close', () => {
    swiper.autoplay.start();
  });

});